import type { CustomerMembershipDto } from "../../../api/hooks/useMemberships";

type BadgeSource = Pick<CustomerMembershipDto, "badgeColour" | "badgeLetters" | "platformName">;

/** Hidden from screen readers: the membership's name is always written beside it. */
export function MembershipBadge({
  membership,
  size = 20,
}: {
  membership: BadgeSource;
  size?: number;
}) {
  const letters =
    membership.badgeLetters ?? membership.platformName.charAt(0).toUpperCase();

  return (
    <span
      aria-hidden
      className="d-inline-flex align-items-center justify-content-center fw-bold text-white flex-shrink-0"
      style={{
        width: size,
        height: size,
        borderRadius: size / 4,
        background: membership.badgeColour,
        fontSize: size * 0.5,
        lineHeight: 1,
      }}
    >
      {letters}
    </span>
  );
}

/** One badge per membership, overlapping. */
export function MembershipBadgeStack({
  memberships,
}: {
  memberships: CustomerMembershipDto[];
}) {
  return (
    <span className="d-inline-flex flex-shrink-0">
      {memberships.map((membership, index) => (
        <span
          key={membership.id}
          className="d-inline-flex rounded"
          style={{
            marginLeft: index === 0 ? 0 : -6,
            boxShadow: index === 0 ? undefined : "0 0 0 2px var(--cui-tertiary-bg)",
          }}
        >
          <MembershipBadge membership={membership} />
        </span>
      ))}
    </span>
  );
}
